import React, { FC } from 'react';
import { useParams } from 'react-router';
import { Grid, Typography } from '@material-ui/core';
import { useI18nPath } from '../../../../config/clientRoutes/hooks';
import { ExerciseSeriesInfo } from '../../../../config/api/models/Exercise';
import { BlankLink } from '../../../shared/components';
import { SeriesCardPaper } from '../TrajectoryDetail/SeriesCard/index';
import { UrlParams } from '../../../shared/types';
import TotalExercisesByLevel from './TotalExercisesByLevel';

type Props = {
  series: ExerciseSeriesInfo;
};

const AuthorSeriesItem: FC<Props> = ({ series }) => {
  const { getPath } = useI18nPath();
  const { bookId, chapterId, trajectoryId, sectionCode, sectionName } = useParams<UrlParams>();

  return (
    <Grid item xs={6} sm={4}>
      <BlankLink
        to={getPath('trajectoryView', {
          bookId: bookId,
          chapterId,
          trajectoryId,
          'sectionCode?': sectionCode,
          'sectionName?': sectionName,
          'seriesId?': series.id,
        })}
      >
        <SeriesCardPaper elevation={0}>
          <Typography variant="h3">{series.title}</Typography>
          <TotalExercisesByLevel series={series} />
        </SeriesCardPaper>
      </BlankLink>
    </Grid>
  );
};

export default AuthorSeriesItem;
